// extracted by mini-css-extract-plugin
module.exports = {"cardBg":"styles_cardBg__22umV","line":"styles_line__3Bg4x"};